import { observatoryData } from "../config";
import {
  getCurrentObservatoryName,
  cleanNullData,
  startUpperCase,
} from "../utils";

/**
 * Set the text of a element selected by id
 * @param {string} nodeID - the html id to search for
 * @param {any} dirtyText - what to set as innerText, "dirty" as in cleanNullData has
 * not been run
 */
function updateNodeText(nodeID, dirtyText) {
  const node = document.getElementById(nodeID);

  node.innerText = startUpperCase(cleanNullData(dirtyText));
}

function updateNodeHTML(nodeID, dirtyText) {
  const node = document.getElementById(nodeID);
  node.innerHTML = startUpperCase(cleanNullData(dirtyText));
}

export function getSunOverview(astroSnapshot) {
  let sunStatus = astroSnapshot.sun_visibility;
  if (
    astroSnapshot.sun_time_until !== null &&
    astroSnapshot.sun_next_event !== null
  )
    sunStatus =
      sunStatus +
      ` <br /><span class="detail-subtext">${astroSnapshot.sun_time_until} until ${astroSnapshot.sun_next_event}</span>`;
  return sunStatus;
}

export function getMoonOverview(astroSnapshot) {
  let moonStatus = astroSnapshot.moon_visibility;
  if (astroSnapshot.moon_illumination !== null) {
    moonStatus =
      moonStatus +
      ` <br /><span class="detail-subtext">${Math.round(
        astroSnapshot.moon_illumination * 100
      )}% illuminated</span>`;
  }
  return moonStatus;
}

export function getMoonIllumination(astroSnapshot) {
  return `${Math.round(astroSnapshot.moon_illumination * 100)}% illuminated`;
}

/**
 * Functions called by utils.refreshObservatoryData
 */

export async function updateAstronomicalOverview() {
  const observatoryName = getCurrentObservatoryName();
  const astroInfo = observatoryData[observatoryName].astronomicalSnapshot;
  await astroInfo.update();

  updateNodeHTML("ov-astro-sun-visibility", getSunOverview(astroInfo));
  updateNodeHTML("ov-astro-moon-visibility", getMoonOverview(astroInfo));
}

export async function updateWeatherOverview() {
  const observatoryName = getCurrentObservatoryName();
  const weatherInfo = observatoryData[observatoryName].weatherSnapshot;
  await weatherInfo.update();

  updateNodeText("ov-weather-temperature", weatherInfo.temperature);
  updateNodeText("ov-weather-humidity", weatherInfo.humidity);
  updateNodeText("ov-weather-windspeed", weatherInfo.wind_speed_moving_average);
  updateNodeText("ov-weather-rainfall", weatherInfo.rainfall_today);
}

export async function updateVisibilityOverview() {
  const observatoryName = getCurrentObservatoryName();
  const visibilityInfo = observatoryData[observatoryName].visibilitySnapshot;
  await visibilityInfo.update();

  updateNodeText("ov-vis-clarity", visibilityInfo.clarity);
  updateNodeText("ov-vis-darkness", visibilityInfo.darkness);
}

export async function updatePowerOverview() {
  const observatoryName = getCurrentObservatoryName();
  const powerInfo = observatoryData[observatoryName].powerSnapshot;
  await powerInfo.update();

  updateNodeText("ov-power-charge", powerInfo.battery_state_of_charge);
  updateNodeText("ov-power-status", powerInfo.battery_state);
}
